(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    

(function () {
  if (window.__porphisEngravingTextV2) return;
  window.__porphisEngravingTextV2 = true;
  const selector = '[data-engraving-custom-text]';
  const values = new Map();
  const initialized = new WeakSet();
  const keyFor = input => 'porphis-engraving:' + input.getAttribute('form');
  function restore(input) {
    if (initialized.has(input)) return;
    initialized.add(input);
    const key = keyFor(input);
    let value = values.get(key);
    if (value === undefined) {
      try { value = sessionStorage.getItem(key); } catch (_) {}
    }
    if (value != null) input.value = value;
  }
  function scan(scope) {
    if (scope.matches?.(selector)) restore(scope);
    scope.querySelectorAll?.(selector).forEach(restore);
  }
  document.addEventListener('input', event => {
    if (!event.target.matches?.(selector)) return;
    const key = keyFor(event.target);
    values.set(key, event.target.value);
    try { sessionStorage.setItem(key, event.target.value); } catch (_) {}
  });
  function start() {
    scan(document);
    new MutationObserver(records => {
      for (const record of records) {
        for (const node of record.addedNodes) if (node.nodeType === 1) scan(node);
      }
    }).observe(document.body, {childList: true, subtree: true});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
})();


document.addEventListener('click', function (event) {

  /* 点击产品页的核心服务 */
  const trigger = event.target.closest('.porphis-core-service__row');

  if (trigger) {
    const servicesContainer = trigger.closest('.porphis-core-services');
    const modal = servicesContainer?.querySelector('[data-porphis-services-modal]');

    if (!modal) return;

    const serviceIndex = trigger.getAttribute('data-porphis-service');

    const items = modal.querySelectorAll(
      '[data-porphis-modal-service]'
    );

    items.forEach(function (item) {
      const itemIndex = item.getAttribute('data-porphis-modal-service');

      item.classList.toggle(
        'is-active',
        itemIndex === serviceIndex
      );
    });

    if (!modal.open) modal.showModal();
    return;
  }


  /* 点击弹窗里的其他核心服务 */
  const modalItem = event.target.closest(
    '[data-porphis-modal-service]'
  );

  if (modalItem) {
    const modal = modalItem.closest('dialog');

    if (!modal) return;

    const items = modal.querySelectorAll(
      '[data-porphis-modal-service]'
    );

    items.forEach(function (item) {
      item.classList.remove('is-active');
    });

    modalItem.classList.add('is-active');

    return;
  }


/* 点击关闭按钮 */
const closeButton = event.target.closest('.porphis-core-service__close');

if (closeButton) {
  const modal = closeButton.closest('dialog');

  if (modal) {
    modal.classList.add('is-closing');

    setTimeout(function () {
      modal.close();
      modal.classList.remove('is-closing');
    }, 250);
  }

  return;
}


/* 点击弹窗外部 */
const modal = event.target.closest('.porphis-core-service__modal');

if (modal && event.target === modal) {
  modal.classList.add('is-closing');

  setTimeout(function () {
    modal.close();
    modal.classList.remove('is-closing');
  }, 250);
}

});

(function () {
  function getInputs() {
    const sticky = document.querySelector('[data-sticky-quantity] .quantity__input');
    if (!sticky) return null;

    // 从 sticky 的 id 里提取 section+product 后缀
    // sticky id 格式：StickyQuantity-{sectionId}-{productId}
    const m = sticky.id.match(/^StickyQuantity-(.+)$/);
    if (!m) return null;
    const suffix = m[1];

    // 主 input id 格式：Quantity-{sectionId}-{productId}
    const main = document.getElementById('Quantity-' + suffix);
    if (!main) return null;

    return { sticky, main };
  }

  function clamp(input, val) {
    const min = parseInt(input.dataset.min || input.min || '1', 10) || 1;
    const max = input.dataset.max ? parseInt(input.dataset.max, 10) : Infinity;
    let n = parseInt(val, 10);
    if (isNaN(n)) n = min;
    if (n < min) n = min;
    if (n > max) n = max;
    return n;
  }

  let syncing = false;

  function sync(source, target) {
    if (syncing) return;
    syncing = true;
    const v = clamp(source, source.value);
    if (source.value != v) source.value = v;
    if (target.value != v) target.value = v;
    syncing = false;
  }

  function attach() {
    const pair = getInputs();
    if (!pair) return;
    const { sticky, main } = pair;

    // 用 id 作为去重键，确保只绑一次
    const key = sticky.id + '|' + main.id;
    if (sticky.dataset.syncKey === key) return;
    sticky.dataset.syncKey = key;

    const stickyRoot = sticky.closest('quantity-input');
    const mainRoot = main.closest('quantity-input');

    const bind = (source, target) => {
      const root = source.closest('quantity-input');
      if (!root) return;
      // 拦截所有 input / change / click 事件，直接同步值
      const handler = () => {
        setTimeout(() => sync(source, target), 0);
      };
      root.addEventListener('input', handler, true);
      root.addEventListener('change', handler, true);
      root.addEventListener('click', handler, true);
    };

    if (stickyRoot && mainRoot) {
      bind(sticky, main);
      bind(main, sticky);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attach, { once: true });
  } else {
    attach();
  }
  window.addEventListener('scroll', attach, { passive: true });
  window.addEventListener('resize', attach);
  document.addEventListener('shopify:section:load', attach);

  let pending = false;
  new MutationObserver(() => {
    if (pending) return;
    pending = true;
    requestAnimationFrame(() => {
      pending = false;
      attach();
    });
  }).observe(document.body, { childList: true, subtree: true });

  setInterval(attach, 800);
})();

(function () {
  let bound = false;

  function initStickyVariantPicker() {
    const trigger = document.querySelector('[data-sticky-variant-trigger]');
    const list = document.querySelector('[data-sticky-variant-list]');
    const label = document.querySelector('[data-sticky-variant-label]');
    const pickerRoot = document.querySelector('[data-sticky-variant-picker]');
    if (!trigger || !list || !pickerRoot) return;
    if (bound) return;

    const productInfo = document.querySelector('product-info');
    if (!productInfo) return;

    const mainHiddenInput = productInfo.querySelector('form[action*="/cart/add"] input[name="id"]');
    if (!mainHiddenInput) return;

    bound = true;

    // 用 option 的 data-options 反查 radios
    const getRadioGroups = () => {
      const radios = [...productInfo.querySelectorAll('input[type="radio"]')]
        .filter(r => r.name.includes('__main-product'));
      const groups = {};
      radios.forEach(r => {
        const optName = r.name.split('-template--')[0];
        if (!groups[optName]) groups[optName] = [];
        groups[optName].push(r);
      });
      return Object.values(groups);
    };

    // 当前选中的 variant id（自定义下拉不依赖 select 了）
    let currentVariantId = mainHiddenInput.value;

    function closeList() {
      if (list) list.hidden = true;
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      if (pickerRoot) pickerRoot.classList.remove('is-open');
    }

    function openList() {
      if (list) list.hidden = false;
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
      if (pickerRoot) pickerRoot.classList.add('is-open');
    }

    if (trigger && list) {
      trigger.addEventListener('click', (e) => {
        e.stopPropagation();
        if (list.hidden) openList();
        else closeList();
      });

      document.addEventListener('click', (e) => {
        if (pickerRoot && !pickerRoot.contains(e.target)) closeList();
      });

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') closeList();
      });
    }

    // 自定义下拉：点击选项
    if (list) {
      list.addEventListener('click', (e) => {
        const opt = e.target.closest('.product-sticky-form__variant-option');
        if (!opt) return;
        if (opt.classList.contains('is-disabled')) return;

        const variantId = opt.dataset.value;
        const options = (opt.dataset.options || '').split('||').map(s => s.trim()).filter(Boolean);

        // 更新 label
        if (label) label.textContent = opt.textContent.trim();

        // 更新选中样式
        list.querySelectorAll('.product-sticky-form__variant-option').forEach((o) => o.classList.remove('is-selected'));
        opt.classList.add('is-selected');

        currentVariantId = variantId;

        closeList();

        // 勾主 radio
        const radioGroups = getRadioGroups();
        radioGroups.forEach((group, i) => {
          const targetValue = options[i];
          if (targetValue == null) return;
          const radio = group.find(r => r.value === targetValue);
          if (radio && !radio.checked) {
            radio.checked = true;
            radio.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });

        refreshSticky(variantId);
      });
    }

    // 主区域 -> 自定义下拉的 label 同步
    const syncLabelFromMain = () => {
      if (!label) return;
      const currentId = mainHiddenInput.value;
      currentVariantId = currentId;
      const opt = list.querySelector('.product-sticky-form__variant-option[data-value="' + currentId + '"]');
      if (opt) {
        label.textContent = opt.textContent.trim();
        list.querySelectorAll('.product-sticky-form__variant-option').forEach((o) => o.classList.remove('is-selected'));
        opt.classList.add('is-selected');
      }
    };

    // 刷新 Sticky 左侧信息
    // variantId 从外面传进来，避免异步读值读到旧的
    const refreshSticky = (variantId) => {
      const stickyMediaWrap = document.querySelector('[data-sticky-product-media]');
      const stickyPrice = document.querySelector('[id^="StickyPrice-"]');
      const stickyVariantTitle = document.querySelector('[data-sticky-product-options]');

      // 变体标题：从自定义下拉里找对应 option 的文字
      if (stickyVariantTitle) {
        const opt = list.querySelector('.product-sticky-form__variant-option[data-value="' + variantId + '"]');
        if (opt) {
          stickyVariantTitle.textContent = opt.textContent.replace(/\s*-\s*Sold out\s*$/i, '').trim();
        }
      }

      // 主图：从变体 JSON 里取
      if (stickyMediaWrap) {
        const jsonEl = document.querySelector('[data-sticky-variants-json]');
        if (!jsonEl) return;
        let data;
        try { data = JSON.parse(jsonEl.textContent); } catch (e) { return; }
        const variant = data.variants.find(v => String(v.id) === String(variantId));
        if (!variant) return;

        const img = stickyMediaWrap.querySelector('img');
        if (!img) return;

        let src = '';
        const featuredId = variant.featured_media?.id;
        if (featuredId) {
          const m = data.media.find(x => String(x.id) === String(featuredId));
          if (m) src = (m.preview_image || m).src;
        }
        if (!src && variant.featured_image?.src) {
          src = variant.featured_image.src;
        }
        if (!src && data.media[0]) {
          src = (data.media[0].preview_image || data.media[0]).src;
        }

        if (src) {
          const finalSrc = src.startsWith('//') ? ('https:' + src) : src;
          const url = new URL(finalSrc);
          url.searchParams.set('width', '160');
          img.removeAttribute('srcset');
          img.removeAttribute('sizes');
          img.src = url.toString();
        }
      }

      // 价格：等主区域更新完再抄（用 rAF 双帧，比 setTimeout 更可靠）
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          const mainPrice = document.querySelector('product-info [id^="Price-"]');
          if (stickyPrice && mainPrice) {
            stickyPrice.innerHTML = mainPrice.innerHTML;
          }
        });
      });

      // Sale badge 显示/隐藏 + 金额
      const saleBadge = document.querySelector('.product-sticky-form__sale-badge');
      const jsonEl2 = document.querySelector('[data-sticky-variants-json]');
      if (saleBadge && jsonEl2) {
        let d2;
        try { d2 = JSON.parse(jsonEl2.textContent); } catch (e) { d2 = null; }
        if (d2) {
          const v2 = d2.variants.find(v => String(v.id) === String(variantId));
          const compare = v2 && v2.compare_at_price;
          const price = v2 && v2.price;
          const onSale = compare && price && compare > price;
          if (onSale) {
            const save = compare - price;
            const money = (save / 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            const currencyCode = window.Shopify?.currency?.active || 'USD';
            const symbolMap = { USD: '$', EUR: '€', GBP: '£', JPY: '¥', CNY: '¥', CAD: 'CA$', AUD: 'A$' };
            const symbol = symbolMap[currencyCode] || '';
            saleBadge.textContent = 'Save ' + symbol + money;
            saleBadge.style.setProperty('display', 'inline-flex', 'important');
          } else {
            saleBadge.style.setProperty('display', 'none', 'important');
          }
        }
      }

      // 按钮可用状态：按变体 JSON 的 available 更新
      const jsonEl = document.querySelector('[data-sticky-variants-json]');
      if (jsonEl) {
        let data;
        try { data = JSON.parse(jsonEl.textContent); } catch (e) { data = null; }
        if (data) {
          const variant = data.variants.find(v => String(v.id) === String(variantId));
          const available = variant ? variant.available !== false : true;

          const atcBtn = document.querySelector('.product-sticky-form__atc');
          const buyNowBtn = document.querySelector('.product-sticky-form__buynow');

          if (atcBtn) {
            if (available) {
              atcBtn.removeAttribute('disabled');
              atcBtn.removeAttribute('aria-disabled');
            } else {
              atcBtn.setAttribute('disabled', '');
            }
          }

          if (buyNowBtn) {
            if (available) {
              buyNowBtn.removeAttribute('disabled');
              buyNowBtn.removeAttribute('aria-disabled');
            } else {
              buyNowBtn.setAttribute('disabled', '');
            }
          }

          // 同步 Buy Now form 里的隐藏 variant id
          const stickyBuyNowForm = document.querySelector('.product-sticky-form__buynow-form');
          if (stickyBuyNowForm) {
            const stickyBuyNowIdInput = stickyBuyNowForm.querySelector('input[name="id"]');
            if (stickyBuyNowIdInput) {
              stickyBuyNowIdInput.value = variantId;
            }
          }
        }
      }
    };

    // 主 radio -> 自定义下拉
    productInfo.addEventListener('change', (e) => {
      if (e.target.matches('input[type="radio"][name*="__main-product"]')) {
        setTimeout(syncLabelFromMain, 0);
      }
    }, true);

    // 兜底：主隐藏 input 的值被主题改时同步回自定义下拉
    const desc = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value');
    Object.defineProperty(mainHiddenInput, 'value', {
      get() { return desc.get.call(this); },
      set(v) {
        desc.set.call(this, v);
        if (currentVariantId !== String(v)) {
          currentVariantId = String(v);
          syncLabelFromMain();
        }
      },
      configurable: true,
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyVariantPicker, { once: true });
  } else {
    initStickyVariantPicker();
  }
  document.addEventListener('shopify:section:load', initStickyVariantPicker);
})();

(function () {
  let hasApplied = false;

  function applyStickyMobileStyles() {
    const isMobile = window.matchMedia('(max-width: 1023px)').matches;

    const title = document.querySelector('.product-sticky-form__title');
    const trigger = document.querySelector('.product-sticky-form__variant-trigger');
    const arrow = document.querySelector('.product-sticky-form__variant-arrow');
    const qty = document.querySelector('.product-sticky-form__quantity .quantity');
    const qtyBtns = document.querySelectorAll('.product-sticky-form__quantity .quantity__button');
    const qtyInput = document.querySelector('.product-sticky-form__quantity .quantity__input');
    const btns = document.querySelector('.product-sticky-form__buttons');
    const atc = document.querySelector('.product-sticky-form__buttons .product-sticky-form__atc');
    const atcSvg = document.querySelector('.product-sticky-form__buttons .product-sticky-form__atc svg');
    const buyNow = document.querySelector('.product-sticky-form__buttons .product-sticky-form__buynow');
    const variantRow = document.querySelector('.product-sticky-form__variant');

    if (!trigger && !qty && !btns) return false;

    if (!isMobile) {
      if (title) title.style.removeProperty('display');
      if (trigger) {
        trigger.style.removeProperty('height');
        trigger.style.removeProperty('min-height');
        trigger.style.removeProperty('max-height');
        trigger.style.removeProperty('padding');
        trigger.style.removeProperty('font-size');
        trigger.style.removeProperty('border');
        trigger.style.removeProperty('border-radius');
        trigger.style.removeProperty('background');
        trigger.style.removeProperty('color');
        trigger.style.removeProperty('box-sizing');
        trigger.style.removeProperty('display');
        trigger.style.removeProperty('align-items');
        trigger.style.removeProperty('justify-content');
      }
      if (arrow) arrow.style.removeProperty('right');
      if (qty) {
        qty.style.removeProperty('height');
        qty.style.removeProperty('min-height');
        qty.style.removeProperty('max-height');
      }
      qtyBtns.forEach(b => {
        b.style.removeProperty('width');
        b.style.removeProperty('height');
        const svg = b.querySelector('svg');
        if (svg) {
          svg.style.removeProperty('width');
          svg.style.removeProperty('height');
        }
      });
      if (qtyInput) {
        qtyInput.style.removeProperty('width');
        qtyInput.style.removeProperty('height');
        qtyInput.style.removeProperty('font-size');
      }
      if (btns) {
        btns.style.removeProperty('height');
        btns.style.removeProperty('min-height');
        btns.style.removeProperty('max-height');
        btns.style.removeProperty('flex');
        btns.style.removeProperty('min-width');
      }
      if (atc) {
        atc.style.removeProperty('flex');
        atc.style.removeProperty('width');
      }
      if (atcSvg) {
        atcSvg.style.removeProperty('width');
        atcSvg.style.removeProperty('height');
      }
      if (buyNow) buyNow.style.removeProperty('font-size');
      if (variantRow) variantRow.style.removeProperty('gap');
      return true;
    }

    if (title) title.style.setProperty('display', 'none', 'important');

    if (trigger) {
      trigger.style.setProperty('height', '40px', 'important');
      trigger.style.setProperty('min-height', '40px', 'important');
      trigger.style.setProperty('max-height', '40px', 'important');
      trigger.style.setProperty('padding', '0 28px 0 12px', 'important');
      trigger.style.setProperty('font-size', '12px', 'important');
      trigger.style.setProperty('border', '1px solid #e5e7eb', 'important');
      trigger.style.setProperty('border-radius', '999px', 'important');
      trigger.style.setProperty('background', '#ffffff', 'important');
      trigger.style.setProperty('color', '#333333', 'important');
      trigger.style.setProperty('box-sizing', 'border-box', 'important');
      trigger.style.setProperty('display', 'flex', 'important');
      trigger.style.setProperty('align-items', 'center', 'important');
      trigger.style.setProperty('justify-content', 'space-between', 'important');
    }

    if (arrow) arrow.style.setProperty('right', '12px', 'important');

    if (qty) {
      qty.style.setProperty('height', '34px', 'important');
      qty.style.setProperty('min-height', '34px', 'important');
      qty.style.setProperty('max-height', '34px', 'important');
      const qtyWrap = qty.closest('.product-sticky-form__quantity');
      if (qtyWrap) {
        qtyWrap.style.setProperty('flex', '0 0 auto', 'important');
      }
    }

    if (variantRow) {
      variantRow.style.setProperty('gap', '14px 8px', 'important');
    }

    qtyBtns.forEach(b => {
      b.style.setProperty('width', '28px', 'important');
      b.style.setProperty('height', '34px', 'important');
      const svg = b.querySelector('svg');
      if (svg) {
        svg.style.setProperty('width', '14px', 'important');
        svg.style.setProperty('height', '14px', 'important');
      }
    });

    if (qtyInput) {
      qtyInput.style.setProperty('width', '32px', 'important');
      qtyInput.style.setProperty('height', '34px', 'important');
      qtyInput.style.setProperty('font-size', '13px', 'important');
    }

    if (btns) {
      btns.style.setProperty('height', '34px', 'important');
      btns.style.setProperty('min-height', '34px', 'important');
      btns.style.setProperty('max-height', '34px', 'important');
      btns.style.setProperty('flex', '1 1 auto', 'important');
      btns.style.setProperty('min-width', '0', 'important');
    }

    if (atc) {
      atc.style.setProperty('flex', '0 0 40px', 'important');
      atc.style.setProperty('width', '40px', 'important');
    }

    if (atcSvg) {
      atcSvg.style.setProperty('width', '18px', 'important');
      atcSvg.style.setProperty('height', '18px', 'important');
    }

    if (buyNow) buyNow.style.setProperty('font-size', '13px', 'important');

    return true;
  }

  function run() {
    const ok = applyStickyMobileStyles();
    if (ok) hasApplied = true;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }

  window.addEventListener('resize', run);
  document.addEventListener('shopify:section:load', run);

  // 滚动时（Sticky 表单懒加载出现）也跑一次
  window.addEventListener('scroll', () => {
    if (!hasApplied) run();
  }, { passive: true });

  // 兜底：DOM 变动也跑，节流
  let pending = false;
  const observer = new MutationObserver(() => {
    if (pending) return;
    pending = true;
    requestAnimationFrame(() => {
      pending = false;
      run();
    });
  });
  observer.observe(document.body, { childList: true, subtree: true });

  // 前 3 秒内每 300ms 跑一次，确保 Sticky 表单出现时能捕获
  let ticks = 0;
  const interval = setInterval(() => {
    ticks++;
    run();
    if (ticks >= 10) clearInterval(interval);
  }, 300);
})();

(function () {
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.product-sticky-form__buynow');
    if (!btn) return;
    const form = btn.closest('form.product-sticky-form__buynow-form');
    if (!form) return;
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    const idInput = form.querySelector('input[name="id"]');
    const qtyInput = form.querySelector('input[name="quantity"]');
    if (!idInput) return;

    const body = {
      items: [{
        id: idInput.value,
        quantity: qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1
      }]
    };

    btn.setAttribute('disabled', '');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    })
    .then(function () {
      window.location.href = '/checkout';
    })
    .catch(function () {
      btn.removeAttribute('disabled');
    });
  }, true);
})();

(function () {
  let lastY = window.scrollY;
  let direction = 'down';

  function getCard() {
    return document.querySelector('.product-sticky-form__card');
  }

  function isProductInfoVisible() {
    const el = document.querySelector('product-info');
    if (!el) return true;
    const rect = el.getBoundingClientRect();
    return rect.bottom > 0 && rect.top < window.innerHeight;
  }

  function showCard() {
    const card = getCard();
    if (!card) return;
    card.style.setProperty('transition', 'opacity 0.35s ease, transform 0.35s ease, visibility 0.35s ease');
    card.style.setProperty('opacity', '1', 'important');
    card.style.setProperty('visibility', 'visible', 'important');
    card.style.setProperty('pointer-events', 'auto', 'important');
    card.style.setProperty('transform', 'translateY(0)', 'important');
  }

  function hideCard() {
    const card = getCard();
    if (!card) return;
    card.style.setProperty('transition', 'opacity 0.35s ease, transform 0.35s ease, visibility 0.35s ease');
    card.style.setProperty('opacity', '0', 'important');
    card.style.setProperty('visibility', 'hidden', 'important');
    card.style.setProperty('pointer-events', 'none', 'important');
    card.style.setProperty('transform', 'translateY(100%)', 'important');
  }

  function applyVisibility() {
    // 浏览 product-info 分区时不展示
    if (isProductInfoVisible()) {
      hideCard();
      return;
    }
    // 页面向上滑动 → 不展示
    if (direction === 'up') {
      hideCard();
      return;
    }
    // 页面向下滑动且离开 product-info → 展示
    showCard();
  }

  window.addEventListener('scroll', () => {
    const y = window.scrollY;
    if (y > lastY + 2) direction = 'up';      // scrollY 变大 = 页面向上滑动
    else if (y < lastY - 2) direction = 'down'; // scrollY 变小 = 页面向下滑动
    lastY = y;
    applyVisibility();
  }, { passive: true });

  window.addEventListener('resize', applyVisibility);
  document.addEventListener('shopify:section:load', applyVisibility);

  applyVisibility();

  let tries = 0;
  const t = setInterval(() => {
    applyVisibility();
    if (++tries > 20) clearInterval(t);
  }, 300);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-comparison"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('porphis-product-comparison')) return;
  class PorphisProductComparison extends HTMLElement {
    connectedCallback() {
      this.initTimer = setTimeout(() => this.init(), 0);
    }
    disconnectedCallback() {
      clearTimeout(this.initTimer);
      cancelAnimationFrame(this.frame);
      this.abort?.abort();
      this.resizeObserver?.disconnect();
    }
    init() {
      this.abort?.abort();
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.scroll = this.querySelector('[data-table-scroll]');
      this.head = this.querySelector('[data-head]');
      if (!this.scroll || !this.head) return;
      this.picker = this.querySelector('.pc__picker');
      this.sticky = this.querySelector('[data-sticky]');
      this.stickyScroll = this.querySelector('[data-sticky-scroll]');
      this.choices = [...this.querySelectorAll('[data-choice]')];
      this.templates = new Map();
      this.querySelectorAll('template[data-variant-template]').forEach(t => {
        this.templates.set(`${t.dataset.block}:${t.dataset.variantTemplate}`, t);
      });
      this.addEventListener('change', event => {
        if (event.target.matches('[data-choice]')) this.applySelection();
        if (event.target.matches('[data-highlight]')) this.highlight();
        if (event.target.matches('[data-variant]')) this.applyVariant(event.target.dataset.block, event.target.value);
      }, { signal });
      document.addEventListener('click', event => {
        if (!this.picker.contains(event.target)) this.picker.open = false;
      }, { signal });
      this.addEventListener('keydown', event => {
        if (event.key === 'Escape' && this.picker.open) {
          this.picker.open = false;
          this.picker.querySelector('summary').focus();
        }
      }, { signal });
      this.addEventListener('shopify:block:select', event => {
        const blockId = event.detail?.blockId;
        const choice = this.choices.find(input => input.dataset.choice === blockId);
        if (!choice) return;
        choice.checked = true;
        this.applySelection();
        const card = [...this.head.querySelectorAll('.pc__card')].find(el => el.dataset.block === blockId);
        if (card) {
          const labelWidth = this.head.querySelector('.pc__label').offsetWidth;
          this.scroll.scrollLeft += card.getBoundingClientRect().left - this.scroll.getBoundingClientRect().left - labelWidth;
        }
      }, { signal });
      this.scroll.addEventListener('scroll', () => {
        if (this.stickyScroll && Math.abs(this.stickyScroll.scrollLeft - this.scroll.scrollLeft) > 1) this.stickyScroll.scrollLeft = this.scroll.scrollLeft;
        this.scheduleSticky();
      }, { signal, passive: true });
      this.stickyScroll?.addEventListener('scroll', () => {
        if (Math.abs(this.scroll.scrollLeft - this.stickyScroll.scrollLeft) > 1) this.scroll.scrollLeft = this.stickyScroll.scrollLeft;
      }, { signal, passive: true });
      window.addEventListener('scroll', () => this.scheduleSticky(), { signal, passive: true });
      window.addEventListener('resize', () => this.scheduleSticky(), { signal, passive: true });
      this.resizeObserver?.disconnect();
      this.resizeObserver = new ResizeObserver(() => this.scheduleSticky());
      this.resizeObserver.observe(this.scroll);
      if (this.sticky) this.resizeObserver.observe(this.sticky);
      let drag = null;
      this.scroll.addEventListener('pointerdown', event => {
        if (event.pointerType !== 'mouse' || event.button !== 0 || event.target.closest('a,button,select,input,label') || this.scroll.scrollWidth <= this.scroll.clientWidth) return;
        drag = { x: event.clientX, left: this.scroll.scrollLeft, id: event.pointerId };
        this.scroll.setPointerCapture(event.pointerId);
        this.scroll.classList.add('is-dragging');
      }, { signal });
      this.scroll.addEventListener('pointermove', event => {
        if (!drag || event.pointerId !== drag.id) return;
        this.scroll.scrollLeft = drag.left - (event.clientX - drag.x);
      }, { signal });
      const stopDrag = () => { drag = null; this.scroll.classList.remove('is-dragging'); };
      this.scroll.addEventListener('pointerup', stopDrag, { signal });
      this.scroll.addEventListener('pointercancel', stopDrag, { signal });
      this.scroll.addEventListener('lostpointercapture', stopDrag, { signal });
      this.head.querySelectorAll('[data-variant]').forEach(select => this.applyVariant(select.dataset.block, select.value));
      this.applySelection();
    }
    applySelection() {
      const selected = this.choices.filter(c => c.checked).map(c => c.dataset.choice);
      this.querySelectorAll('.pc__cell[data-block]').forEach(cell => {
        const index = selected.indexOf(cell.dataset.block);
        cell.hidden = index === -1;
        cell.classList.toggle('is-even', index >= 0 && index % 2 === 0);
      });
      this.querySelector('[data-empty]').hidden = selected.length > 0;
      this.scroll.hidden = selected.length === 0;
      this.highlight();
      this.scheduleSticky();
    }
    applyVariant(blockId, variantId) {
      const data = this.templates.get(`${blockId}:${variantId}`);
      if (!data) return;
      this.querySelectorAll('.pc__card').forEach(card => {
        if (card.dataset.block !== blockId) return;
        const select = card.querySelector('[data-variant]');
        if (select) select.value = variantId;
        const input = card.querySelector('input[name="id"]');
        if (input) {
          input.value = variantId;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
        const price = card.querySelector('[data-price]');
        if (price) price.textContent = data.dataset.price;
        const compare = card.querySelector('[data-compare-price]');
        if (compare) {
          compare.textContent = data.dataset.comparePrice;
          compare.hidden = !data.dataset.comparePrice;
        }
        const button = card.querySelector('[data-buy]');
        if (button) {
          button.disabled = data.dataset.available !== 'true';
          button.querySelector('[data-buy-label]').textContent = button.disabled ? button.dataset.soldLabel : button.dataset.addLabel;
          if (button.disabled) button.setAttribute('aria-disabled', 'true');
          else button.removeAttribute('aria-disabled');
          const form = button.closest('form');
          if (form) {
            form.error = false;
            const error = form.querySelector('.product-form__error-message');
            if (error) { error.hidden = true; error.textContent = ''; }
          }
        }
        card.querySelectorAll('[data-product-link]').forEach(link => { link.href = data.dataset.url; });
        const img = card.querySelector('.pc__media img');
        if (img && data.dataset.image) {
          img.src = data.dataset.image;
          img.removeAttribute('srcset');
          img.removeAttribute('sizes');
        }
      });
      this.querySelectorAll('[data-spec-row]').forEach(row => {
        const source = data.content.querySelector(`[data-spec="${row.dataset.specRow}"]`);
        const cell = [...row.querySelectorAll('[data-block]')].find(c => c.dataset.block === blockId);
        if (source && cell) cell.querySelector('[data-value]').replaceChildren(...[...source.childNodes].map(node => node.cloneNode(true)));
      });
      this.highlight();
      this.scheduleSticky();
    }
    highlight() {
      const enabled = this.querySelector('[data-highlight]')?.checked;
      this.querySelectorAll('[data-spec-row]').forEach(row => {
        const values = [...row.querySelectorAll('.pc__spec')].filter(cell => !cell.hidden).map(cell => cell.textContent.replace(/\s+/g, ' ').trim().toLowerCase());
        row.classList.toggle('is-different', Boolean(enabled && values.length > 1 && values.some(value => value !== values[0])));
      });
    }
    scheduleSticky() {
      if (this.frame) return;
      this.frame = requestAnimationFrame(() => { this.frame = null; this.updateSticky(); });
    }
    updateSticky() {
      if (!this.sticky || !this.isConnected) return;
      let top = Number(this.dataset.offset) || 0;
      if (this.dataset.belowHeader === 'true') {
        let headerBottom = 0;
        document.querySelectorAll('sticky-header, header[is="sticky-header"], header[is="custom-header"], #shopify-section-header, .shopify-section-group-header-group').forEach(header => {
          const rect = header.getBoundingClientRect();
          if (rect.top <= 2 && rect.bottom > 0 && rect.height < window.innerHeight / 2 && getComputedStyle(header).visibility !== 'hidden') headerBottom = Math.max(headerBottom, rect.bottom);
        });
        top += headerBottom;
      }
      const rect = this.scroll.getBoundingClientRect();
      const head = this.head.getBoundingClientRect();
      this.sticky.style.top = `${top}px`;
      this.sticky.style.left = `${rect.left}px`;
      this.sticky.style.width = `${rect.width}px`;
      const eligible = !this.scroll.hidden && rect.width > 0 && head.bottom <= top;
      this.sticky.hidden = !eligible;
      if (eligible && rect.bottom <= top + this.sticky.offsetHeight + 20) this.sticky.hidden = true;
      if (!this.sticky.hidden) this.stickyScroll.scrollLeft = this.scroll.scrollLeft;
    }
  }
  customElements.define('porphis-product-comparison', PorphisProductComparison);
})();

  } catch(e) { console.error(e); }
})();
})();
